export const routes = {
    public: {
        root: () => "/",
        login: () => "/login",
        error: () => "/error",
        forgotten: () => "/forgotten",
        register: () => "/register",
        reset: () => "/reset",
        terms: () => "/terms"
    },
    adviser: {
        root: () => "/adviser"
    },
    client: {
        root: () => "/client",
        analysis: ({ accountNum = ":accountNum", rangeId = ":rangeId" } = {}) =>
            `/client/analysis/${accountNum}/${rangeId}`,
        authorisations: () => "/client/authorisations",
        changePassword: () => "/client/changePassword",
        contacts: () => "/client/contacts",
        documentPreferencesEdit: ({ documentTypeCode = ":documentTypeCode" } = {}) =>
            `/client/documentPrefsEdit/${documentTypeCode}`,
        documents: ({
            accountNum = ":accountNum",
            rangeId = ":rangeId",
            documentCategory = ":documentCategory"
        } = {}) => `/client/documents/${accountNum}/${rangeId}/${documentCategory}`,
        folioDetails: ({ accountNum = ":accountNum" } = {}) => `/client/folioDetails/${accountNum}`,
        home: () => "/client/home",
        incomeHistory: ({ accountNum = ":accountNum", rangeId = ":rangeId" } = {}) =>
            `/client/incomeHistory/${accountNum}/${rangeId}`,
        legal: () => "/client/legal",
        memoAssets: () => "/client/memoAssets",
        news: () => "/client/news",
        personal: () => "/client/personal",
        transactions: ({ accountNum = ":accountNum", rangeId = ":rangeId" } = {}) =>
            `/client/transactions/${accountNum}/${rangeId}`,
        settings: () => `/client/settings`
    }
};
